import * as i0 from '@angular/core';
import { InjectionToken, Injectable, NgModule, Inject } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, of, EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const TEXTAPI_CLIENT_CONFIG = new InjectionToken('TextApiClientConfig');

class BaseTextFieldDefinition {
}

class EnumBase {
    constructor(name, id) {
        this.name = name;
        this.id = id;
    }
}

class AccessType extends EnumBase {
    constructor(name, id) {
        super(name, id);
    }
    static GetAll() {
        let all = [AccessType.Public, AccessType.Private, AccessType.System];
        return all;
    }
    static FromId(pid) {
        let result = this.GetAll().find((x) => x.id == pid);
        return result;
    }
}
AccessType.Public = new AccessType("Public", "Public");
AccessType.Private = new AccessType("Private", "Private");
AccessType.System = new AccessType("System", "System");
AccessType.Unknown = new AccessType("Unknown Access Type", "UnknownAccessType");

class FieldTypes extends EnumBase {
    constructor(name, id) {
        super(name, id);
    }
}
/// <summary>
/// Get the FieldSet enum.
/// </summary>
FieldTypes.TextSet = new FieldTypes("Text Set", "TextSet");
/// <summary>
/// Get the Number Field enum.
/// </summary>
FieldTypes.NumberField = new FieldTypes('Number Field', 'NumberField');
/// <summary>
/// Get the Multiline plain Field enum.
/// </summary>
FieldTypes.MultiLineTextFieldPlain = new FieldTypes("MultiLine Text Field Plain", 'MultiLineTextFieldPlain');
/// <summary>
/// Get the plain limited multiline enum.
/// </summary>
FieldTypes.MultiLineTextFieldPlainLimited = new FieldTypes("MultiLine Text Field Plain Limited", 'MultiLineTextFieldPlainLimited');
/// <summary>
/// Get the Multiline Mark Down Field enum.
/// </summary>
FieldTypes.MultiLineTextFieldMarkDown = new FieldTypes("MultiLine Text Field MarkDown", 'MultiLineTextFieldMarkDown');
/// <summary>
///  Get the Multiline html enum.
/// </summary>
FieldTypes.MultiLineTextFieldHTML = new FieldTypes("MultiLine Text Field HTML", 'MultiLineTextFieldHTML');
/// <summary>
/// Get the Multiline html limited enum.
/// </summary>
FieldTypes.MultiLineTextFieldHTMLLimited = new FieldTypes("MultiLine Text Field HTML Limited", 'MultiLineTextFieldHTMLLimited');
/// <summary>
/// Get the single Text Field enum.
/// </summary>
FieldTypes.SingleTextFieldPlain = new FieldTypes("Single Text Field Plain", 'SingleTextFieldPlain');
/// <summary>
/// Get the single Text Field Limited enum.
/// </summary>
FieldTypes.SingleTextFieldPlainLimited = new FieldTypes("Single Text Field Plain Limited", 'SingleTextFieldPlainLimited');
/// <summary>
/// Get the Sub Text SEt Field enum
/// </summary>
FieldTypes.SubTextSetField = new FieldTypes("Sub Text Set Field", 'SubTextSetField');
/// <summary>
/// Get the hyperlink field type.
/// </summary>
FieldTypes.Hyperlink = new FieldTypes("Hyperlink", 'Hyperlink');
/// <summary>
/// Get the picklist field type.
/// </summary>
FieldTypes.PickList = new FieldTypes('Pick List', 'PickList');

class FormatTypes extends EnumBase {
    constructor() {
        super(...arguments);
        this.Full = new FormatTypes("Fully Formatable", "Full");
        /// <summary>
        /// Get Limited formatting enum.
        /// </summary>
        this.Limited = new FormatTypes("Limited Formatting", "Limited");
        /// <summary>
        /// Get Micro formatting enum.
        /// </summary>
        this.Micro = new FormatTypes("Basic Formatting", "Micro");
        /// <summary>
        /// Get None formatting enum.
        /// </summary>
        this.None = new FormatTypes("No Formatting", "None");
    }
}

class OwnerType extends EnumBase {
    constructor() {
        super(...arguments);
        this.Person = new OwnerType("Person", "Person");
        /// <summary>
        ///     Team
        /// </summary>
        this.Team = new OwnerType("Team", "Team");
        /// <summary>
        ///     Role
        /// </summary>
        this.Role = new OwnerType("Role", "Role");
    }
}

class VersionType extends EnumBase {
    constructor() {
        super(...arguments);
        this.Previous = new VersionType("Previous Version", "Previous");
        /// <summary>
        /// Get Limited formatting enum.
        /// </summary>
        this.Current = new VersionType("Current Version", "Current");
    }
}

class MultiLineTextFieldHTMLDefinition extends BaseTextFieldDefinition {
    constructor() {
        super(...arguments);
        this.type = FieldTypes.MultiLineTextFieldHTML;
    }
}

class MultiLineTextFieldPlainDefinition extends BaseTextFieldDefinition {
    constructor() {
        super(...arguments);
        this.type = FieldTypes.MultiLineTextFieldPlain;
    }
}

class NumberFieldDefinition {
    constructor() {
        this.type = FieldTypes.NumberField;
    }
}

class SingleTextFieldPlainDefinition extends BaseTextFieldDefinition {
    constructor() {
        super(...arguments);
        this.type = FieldTypes.SingleTextFieldPlain;
    }
}

class SubTextSetDefinition {
    constructor() {
        /// <inheritdoc/>
        this.type = FieldTypes.SubTextSetField;
    }
}

class TextSetDefinition {
}

class PickListFieldDefinition {
    constructor() {
        this.type = FieldTypes.PickList;
    }
}

class HyperlinkFieldDefinition {
    constructor() {
        this.type = FieldTypes.Hyperlink;
    }
}

class BaseTextField {
    constructor() {
        /// <inheritdoc/>
        this.modified = false;
    }
}

class MultiLineTextFieldHTML extends BaseTextField {
}

class MultiLineTextFieldPlain extends BaseTextField {
}

class NumberField {
    constructor() {
        /// <inheritdoc/>
        this.type = FieldTypes.NumberField;
        /// <inheritdoc/>
        this.modified = false;
    }
}

class SingleTextFieldPlain extends BaseTextField {
}

class SubTextSet {
    constructor() {
        this.type = FieldTypes.SubTextSetField;
        /// <inheritdoc/>
        this.modified = false;
    }
}

class TextSet {
    constructor() {
        /// <inheritdoc/>
        this.modified = false;
    }
}

class PickListField {
    constructor() {
        /// <inheritdoc/>
        this.type = FieldTypes.PickList;
        /// <inheritdoc/>
        this.modified = false;
    }
}

class HyperlinkField {
    constructor() {
        /// <inheritdoc/>
        this.type = FieldTypes.Hyperlink;
        /// <inheritdoc/>
        this.modified = false;
    }
}

class Error$1 {
}
class ErrorDetails {
}

class OrganizationDetails {
}

class Owner {
    IsWithinTeam(teamId) {
        if (this.id == teamId)
            return true;
        if (!this.team)
            return false;
        return this.team.IsWithinTeam(teamId);
    }
}

class IPagedList {
}

class TextAuthInterceptor {
    constructor() { }
    /**
     * Get the auth token from the service.
     * Clone the request and replace the original headers with
     * cloned headers, updated with the authorization.
     * send cloned request with header to the next handler.
     *
     * @param req
     * @param next
     */
    intercept(req, next) {
        if (req.url.includes('text-api') ||
            req.url.includes('localhost:57633')) {
            const token = localStorage.getItem(`id_token_delegate_text-api`);
            const authReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`),
            });
            const returnMimeReq = authReq.clone({
                headers: authReq.headers.set('Content-Type', 'application/json'),
            });
            return next.handle(returnMimeReq);
        }
        return next.handle(req);
    }
}
TextAuthInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextAuthInterceptor, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TextAuthInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextAuthInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextAuthInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

const TEXT_SERVICES = [];
class TextServiceModule {
    static forRoot() {
        return {
            ngModule: TextServiceModule,
            providers: [
                TEXT_SERVICES,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: TextAuthInterceptor,
                    multi: true,
                },
            ],
        };
    }
}
TextServiceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextServiceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TextServiceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: TextServiceModule, imports: [HttpClientModule] });
TextServiceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextServiceModule, providers: [
        TEXT_SERVICES,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TextAuthInterceptor,
            multi: true,
        },
    ], imports: [HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        TEXT_SERVICES,
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: TextAuthInterceptor,
                            multi: true,
                        },
                    ],
                    imports: [HttpClientModule],
                    exports: [],
                    declarations: [],
                }]
        }] });

class TextApiSharedService {
    static handleError(operation = 'operation', result) {
        const res = (error) => {
            if (error instanceof HttpErrorResponse) {
                const pError = new Error$1();
                pError.status = error.status;
                pError.statusText = error.statusText;
                pError.details = error.error;
                return throwError(pError);
            }
            const res = of(result);
            return res;
        };
        return res;
    }
}

class JsonEncryptDecrypt {
    constructor() { }
    findReferences(obj, catalog) {
        if (obj && typeof obj === 'object') {
            const id = obj.$id;
            if (typeof id === 'string') {
                catalog[id] = obj;
            }
            if (Object.prototype.toString.apply(obj) === '[object Array]') {
                let i;
                for (i = 0; i < obj.length; i += 1) {
                    this.findReferences(obj[i], catalog);
                }
            }
            else {
                for (const name in obj) {
                    if (obj.hasOwnProperty(name)) {
                        if (typeof obj[name] === 'object') {
                            this.findReferences(obj[name], catalog);
                        }
                    }
                }
            }
        }
    }
    resolveReferences(obj, catalog) {
        if (obj && typeof obj === 'object') {
            let i;
            let item;
            let id;
            if (Object.prototype.toString.apply(obj) === '[object Array]') {
                for (i = 0; i < obj.length; i += 1) {
                    item = obj[i];
                    if (item && typeof item === 'object') {
                        id = item.$ref;
                        if (typeof id === 'string') {
                            obj[i] = catalog[id];
                        }
                        else {
                            obj[i] = this.resolveReferences(item, catalog);
                        }
                    }
                }
            }
            else if (obj.$values && Object.prototype.toString.apply(obj.$values) === '[object Array]') {
                const arr = new Array();
                for (i = 0; i < obj.$values.length; i += 1) {
                    item = obj.$values[i];
                    if (item && typeof item === 'object') {
                        id = item.$ref;
                        if (typeof id === 'string') {
                            arr[i] = catalog[id];
                        }
                        else {
                            arr[i] = this.resolveReferences(item, catalog);
                        }
                    }
                    else {
                        arr[i] = item;
                    }
                }
                obj = arr;
            }
            else {
                let name;
                for (name in obj) {
                    if (obj.hasOwnProperty(name)) {
                        if (typeof obj[name] === 'object') {
                            item = obj[name];
                            if (item) {
                                id = item.$ref;
                                if (typeof id === 'string') {
                                    obj[name] = catalog[id];
                                }
                                else {
                                    obj[name] = this.resolveReferences(item, catalog);
                                }
                            }
                        }
                    }
                }
            }
        }
        return obj;
    }
    getDecycledCopy(obj, catalog) {
        let i;
        let name;
        let nu;
        switch (typeof obj) {
            case 'object':
                if (obj === null ||
                    obj instanceof Boolean ||
                    obj instanceof Date ||
                    obj instanceof Number ||
                    obj instanceof RegExp ||
                    obj instanceof String) {
                    return obj;
                }
                for (i = 0; i < catalog.length; i += 1) {
                    if (catalog[i] === obj) {
                        return { $ref: i.toString() };
                    }
                }
                obj.$id = catalog.length.toString();
                catalog.push(obj);
                if (Object.prototype.toString.apply(obj) === '[object Array]') {
                    nu = [];
                    for (i = 0; i < obj.length; i += 1) {
                        nu[i] = this.getDecycledCopy(obj[i], catalog);
                    }
                }
                else {
                    nu = {};
                    for (name in obj) {
                        if (Object.prototype.hasOwnProperty.call(obj, name)) {
                            nu[name] = this.getDecycledCopy(obj[name], catalog);
                        }
                    }
                }
                return nu;
            case 'number':
            case 'string':
            case 'boolean':
            default:
                return obj;
        }
    }
    decycle(obj) {
        const catalog = [];
        const newObj = this.getDecycledCopy(obj, catalog);
        return newObj;
    }
    retrocycle(obj) {
        const catalog = [];
        this.findReferences(obj, catalog);
        return this.resolveReferences(obj, catalog);
    }
}
JsonEncryptDecrypt.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: JsonEncryptDecrypt, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
JsonEncryptDecrypt.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: JsonEncryptDecrypt, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: JsonEncryptDecrypt, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class TextSetDefinitionsService {
    constructor(http, jsonDecryptEncrypt, config) {
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.config = config;
        this.config = config;
    }
    createTextSetDefinition(textSetDefinition) {
        return this.http.post(`${this.config.TextApiEndpoint}/api/TextSetDefinitions`, textSetDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    listTextSetDefinitions(page = 1, pageSize = 10, privateTagIds, publicTagIds) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        // privateTagIds criteria
        if (privateTagIds) {
            params = params.set('privateTagIds', privateTagIds);
        }
        // publicTagIds criteria
        if (publicTagIds) {
            params = params.set('publicTagIds', publicTagIds);
        }
        return this.http.get(`${this.config.TextApiEndpoint}/api/TextSetDefinitions`, { params: params })
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    getTextSetDefinitionById(id) {
        return this.http.get(`${this.config.TextApiEndpoint}/api/TextSetDefinitions/${id}`)
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    /**
  *
  * @todo: needs matching c# extension and controller methods
  */
    getTextSetVersions(coreId) {
        return EMPTY;
    }
    addMultiLineHTMLDefinition(textSetId, multiLineHTMLDefinition) {
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/addMultiLineTextFieldHTML`, multiLineHTMLDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    addMultiLinePlainDefinition(textSetId, multiLinePlainDefinition) {
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/addMultiLineTextFieldPlain`, multiLinePlainDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    addNumberDefinition(textSetId, numberFieldDefinition) {
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/addNumberField`, numberFieldDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    addSinglePlainDefinition(textSetId, singleFieldPlainDefinition) {
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/addTextFieldPlain`, singleFieldPlainDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    // public addSubTextSetDefinition(textSetId:string, subTextSetDefinition:addSubTextSetDefinitionRequest):Observable<TextSetDefinition>{
    //   return this.http.post<TextSetDefinition>(`${this.config.TextApiEndpoint}/api/${textSetId}/addTextFieldPlain`, singleFieldPlainDefinition)
    //   .pipe(
    //     catchError(
    //       TextApiSharedService.handleError<TextSetDefinition>()
    //     )
    //   );
    // }
    updateTextSetDefinitionFieldName(textSetId, fieldId, name) {
        let updateTExtSetDefinition = {
            name: name
        };
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/field/${fieldId}/UpdateName`, updateTExtSetDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    updateTextSetDefinitionFieldOrder(textSetId, fieldId, order) {
        let updateTExtSetDefinition = {
            order: order
        };
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/field/${fieldId}/UpdateOrder`, updateTExtSetDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    updateTextSetDefinitionFieldRequired(textSetId, fieldId, required) {
        let updateTExtSetDefinition = {
            required: required
        };
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/field/${fieldId}/UpdateRequired`, updateTExtSetDefinition)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
    updateVersion(textSetId) {
        return this.http.post(`${this.config.TextApiEndpoint}/api/${textSetId}/updateVersion`, null)
            .pipe(catchError(TextApiSharedService.handleError()));
    }
}
TextSetDefinitionsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextSetDefinitionsService, deps: [{ token: i1.HttpClient }, { token: JsonEncryptDecrypt }, { token: TEXTAPI_CLIENT_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
TextSetDefinitionsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextSetDefinitionsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextSetDefinitionsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: JsonEncryptDecrypt }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TEXTAPI_CLIENT_CONFIG]
                }] }]; } });

class TextSetsService {
    constructor(config, http, jsonDecryptEncrypt) {
        this.config = config;
        this.http = http;
        this.jsonDecryptEncrypt = jsonDecryptEncrypt;
        this.config = config;
    }
    createTextSet(textSetDefinition, name) {
        return EMPTY;
    }
    addSubTextSetInstance(textSetId, subTextSetFieldId) {
        return this.http.post(`${this.config.TextApiEndpoint}/api/textsets/${textSetId}/fields/${subTextSetFieldId}/addinstance`, {})
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    removeSubTextSetInstance(textSetId, subTextSetFieldId, instanceId) {
        return this.http.delete(`${this.config.TextApiEndpoint}/api/textsets/${textSetId}/fields/${subTextSetFieldId}/instances/${instanceId}/removeinstance`)
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    listTextSets() {
        return EMPTY;
    }
    getTextSetById(textSetId) {
        return EMPTY;
    }
    listByIds(ids) {
        let params = new HttpParams();
        params = params.set('ids', ids.join(','));
        return this.http.get(`${this.config.TextApiEndpoint}/api/textsets/listbyids?${params.toString()}`)
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    list(page = 1, pageSize = 10, onlyLoadVersion1OrGreater = false, textSetDefinitionIds, orgIds, feedIds, tagIds) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        params = params.set('onlyLoadVersion1OrGreater', onlyLoadVersion1OrGreater.toString());
        if (textSetDefinitionIds) {
            params = params.set('textSetDefinitionIds', textSetDefinitionIds.join(','));
        }
        if (orgIds) {
            params = params.set('orgIds', orgIds.join(','));
        }
        if (feedIds) {
            params = params.set('feedIds', feedIds.map(f => f.toString()).join(','));
        }
        if (tagIds) {
            params = params.set('tagIds', tagIds.join(','));
        }
        return this.http.get(`${this.config.TextApiEndpoint}/api/textsets?${params.toString()}`)
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    getTextSet(id) {
        return this.http.get(`${this.config.TextApiEndpoint}/api/textsets/${id}`)
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    getAllVersions(textSetId) {
        return this.http.get(`${this.config.TextApiEndpoint}/api/textsets/${textSetId}/all-versions`)
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
    updateTextSet(textSet) {
        return EMPTY;
    }
    updateField(textSetId, updateField) {
        return EMPTY;
    }
    updateFields(textSetId, updatedFields, markNewVersion = false, errorOnInvalid = false) {
        const request = {
            fields: updatedFields,
            markAsNewVersion: markNewVersion,
            errorOnInvalid: errorOnInvalid,
        };
        return this.http.put(`${this.config.TextApiEndpoint}/api/textsets/${textSetId}/updateFields`, request)
            .pipe(map((result) => this.jsonDecryptEncrypt.retrocycle(result)), catchError(TextApiSharedService.handleError()));
    }
}
TextSetsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextSetsService, deps: [{ token: TEXTAPI_CLIENT_CONFIG }, { token: i1.HttpClient }, { token: JsonEncryptDecrypt }], target: i0.ɵɵFactoryTarget.Injectable });
TextSetsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextSetsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TextSetsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TEXTAPI_CLIENT_CONFIG]
                }] }, { type: i1.HttpClient }, { type: JsonEncryptDecrypt }]; } });

class TextSetExtensions {
    static updateBaseTextFieldValue(field, value) {
        field.value = value;
        field.modified = true;
        field.parent.modified = true;
    }
    static updateSingleTextFieldPlainValue(field, value) {
        this.updateBaseTextFieldValue(field, value);
    }
    static updateHyperlinkFieldValue(field, url, anchorLink) {
        field.value = url;
        field.anchorText = anchorLink;
        field.modified = true;
        field.parent.modified = true;
    }
    static updatePickListFieldValue(field, value) {
        field.value = value;
        field.modified = true;
        field.parent.modified = true;
    }
    static updateNumberFieldValue(field, value) {
        if (typeof value === 'string') {
            field.value = parseInt(value);
        }
        else {
            field.value = value;
        }
        field.modified = true;
        field.parent.modified = true;
    }
    static validateBaseField(field) {
        if ((!field.value || field.value === '') && field.required === true)
            return false;
        return true;
    }
    static validateNumberField(field) {
        if ((!field.value) && field.required === true)
            return false;
        if (field.value && (field.fieldDefinition.minValue && field.fieldDefinition.minValue > field.value || field.fieldDefinition.maxValue && field.fieldDefinition.maxValue < field.value))
            return false;
        return true;
    }
    static validatePickListField(field) {
        if ((!field.value || field.value === '') && field.required === true)
            return false;
        if (field.value && !field.fieldDefinition.pickListValues.includes(field.value))
            return false;
        return true;
    }
    static calculateDepth(field) {
        if (!(field.parent?.parentField)) {
            return 1;
        }
        const next = field.parent?.parentField;
        const depth = 2 + this.calculateDepth(next);
        return depth;
    }
    /**
     * Find the highested textset in a textset tree.
     * @param text
     */
    static findHighest(textSet) {
        if (!textSet.parentField)
            return textSet;
        const parent = textSet.parentField.parent;
        if (!parent)
            throw new Error('Referenced Parent is null');
        const nextUp = this.findHighest(parent);
        return nextUp;
    }
    static extractChanges(textSet) {
        const simpleFields = textSet?.fields
            ?.filter(f => f.modified === true && f.type.id !== FieldTypes.SubTextSetField.id)
            .map(f => {
            // map hyperlnike field specifically
            if (f.type.id === FieldTypes.Hyperlink.id) {
                return { fieldId: f.id, value: { url: f.value, anchorText: f.anchorText } };
            }
            // otherwise normal value only return
            return { fieldId: f.id, value: f.value };
        }) ?? [];
        const deepFields = textSet?.fields
            ?.filter(f => f.type.id === FieldTypes.SubTextSetField.id)
            .filter(f => f.textSets && f.textSets.length > 0)
            .flatMap(f => f.textSets)
            .flatMap(t => {
            const changes = this.extractChanges(t);
            changes.filter(c => !c.textSetId).forEach(c => c.textSetId = t.id);
            return changes;
        }) ?? [];
        const results = simpleFields.concat(deepFields);
        return results;
    }
    static copyTextSet(sourceTextSet, targetTextSet) {
        targetTextSet?.fields?.forEach(tf => {
            const sourceField = sourceTextSet?.fields?.find(ff => ff.fieldDefinition.id === tf.fieldDefinition.id);
            if (sourceField) {
                switch (sourceField.type.id) {
                    case FieldTypes.SubTextSetField.id:
                        // ignore sub text sets for now.
                        break;
                    case FieldTypes.Hyperlink.id:
                        this.updateHyperlinkFieldValue(tf, sourceField.value, sourceField.anchorText);
                        break;
                    case FieldTypes.NumberField.id:
                        this.updateNumberFieldValue(tf, sourceField.value);
                        break;
                    case FieldTypes.PickList.id:
                        this.updatePickListFieldValue(tf, sourceField.value);
                        break;
                    // fallback is generic text field
                    default:
                        this.updateBaseTextFieldValue(tf, sourceField.value);
                }
            }
        });
    }
}

/*
 * Public API Surface of text-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccessType, BaseTextField, BaseTextFieldDefinition, Error$1 as Error, ErrorDetails, FieldTypes, FormatTypes, HyperlinkField, HyperlinkFieldDefinition, IPagedList, JsonEncryptDecrypt, MultiLineTextFieldHTML, MultiLineTextFieldHTMLDefinition, MultiLineTextFieldPlain, MultiLineTextFieldPlainDefinition, NumberField, NumberFieldDefinition, OrganizationDetails, Owner, OwnerType, PickListField, PickListFieldDefinition, SingleTextFieldPlain, SingleTextFieldPlainDefinition, SubTextSet, SubTextSetDefinition, TEXTAPI_CLIENT_CONFIG, TextServiceModule, TextSet, TextSetDefinition, TextSetDefinitionsService, TextSetExtensions, TextSetsService, VersionType };
